enum Locales {
  de = 'de',
  en = 'en',
  fr = 'fr',
  it = 'it',
  cs = 'cs'
}

const commonDateFormat = 'DD.MM.YYYY HH:mm';

const breakpointsPx = {
  sm: '480px',
  md: '744px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  '3xl': '2560px'
};

const supportEmail = 'support@saipient.ch';

const tutorialVideosUrl = 'https://vimeo.com/saipient';

const tutorialVideosUrlByLocale: Partial<Record<Locales, string>> = {
  [Locales.de]: 'https://vimeo.com/showcase/12273562',
  [Locales.fr]: 'https://vimeo.com/showcase/12273575'
};

const productionAppUrl = 'https://app.saipient.ch';

const vocabularyLimit = 60;

const vocabularyAliasLimit = 10;

const preferencesLimit = 20;

const vocabularyCaptureMaxLength = 80;

export {
  Locales,
  commonDateFormat,
  breakpointsPx,
  supportEmail,
  tutorialVideosUrl,
  tutorialVideosUrlByLocale,
  productionAppUrl,
  vocabularyLimit,
  vocabularyAliasLimit,
  preferencesLimit,
  vocabularyCaptureMaxLength
};
